import { render, staticRenderFns } from "./OrdersView3.vue?vue&type=template&id=53132d5d&scoped=true&"
import script from "./OrdersView3.vue?vue&type=script&lang=js&"
export * from "./OrdersView3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53132d5d",
  null
  
)

export default component.exports